import { render } from "./TaxManagement.vue?vue&type=template&id=7ee85b37&scoped=true"
import script from "./TaxManagement.vue?vue&type=script&lang=js"
export * from "./TaxManagement.vue?vue&type=script&lang=js"

import "./TaxManagement.vue?vue&type=style&index=0&id=7ee85b37&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee85b37"]])

export default __exports__